import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiService = new CrudCustom('/pos');
export default TransaksiService;
